import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import ContactForm from './form';
import SectionTitle from './section-title';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6, 0),
    backgroundImage:
      'radial-gradient(87.04% 212.32% at 95.46% -27.14%, #02BBD3 0%, #0030AC 100%)',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(23, 0)
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    marginBottom: theme.spacing(18),
    color: theme.palette.common.white,
    transitionDelay: '0.1s'
  },
  textContent: {
    color: theme.palette.common.white,
    '& p:nth-of-type(n+2)': {
      marginTop: theme.spacing(14)
    },
    [theme.breakpoints.up('md')]: {
      '& p': {
        maxWidth: 500
      }
    }
  },
  formContent: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 480,
      margin: '0 auto'
    }
  },
  d0: {
    transitionDelay: '0.6s'
  },
  d1: {
    transitionDelay: '0.9s'
  },
  d2: {
    transitionDelay: '1.2s'
  }
}));

const ContactUsContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabelContactUs"
            indicators={false}
            reverse={false}
            offset="-200px"
          >
            <div id="whiteLabelContactUs">
              <SectionTitle
                className={clsx(classes.title, classes.animate)}
                title={t('whiteLabelPage.contactUs.title')}
              />
              <Grid container spacing={10}>
                <Grid className={classes.textContent} item xs={12} md={6}>
                  <Typography
                    className={clsx(classes.d0, classes.animate)}
                    variant="body1"
                  >
                    {t('whiteLabelPage.contactUs.text1')}
                  </Typography>
                  <Typography
                    className={clsx(classes.d1, classes.animate)}
                    variant="body1"
                  >
                    {t('whiteLabelPage.contactUs.text2')}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div
                    className={clsx(
                      classes.formContent,
                      classes.d2,
                      classes.animate
                    )}
                  >
                    <ContactForm />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Scene>
        </Controller>
      </Container>
    </section>
  );
};

export default ContactUsContent;
